mp.currencyswitch = {
    current: 'EUR',
    oxr: null,

    init: function () {
        $(document).on('change', '.mpCurrencySelect', mp.currencyswitch.switch);
        $(document).on('click', '.mpCurrencySelect', function(ev) { ev.stopPropagation(); });

        if (typeof(Cookies.get('MP_UserCurrency')) !== 'undefined') {
            mp.currencyswitch.current = Cookies.get('MP_UserCurrency');
        }

        $('#mpEvent').on('contentxhr', mp.currencyswitch.recalculatePrices);
        mp.currencyswitch.recalculatePrices();
    },

    switch: function (ev) {
        var newCurrency = $(ev.target).val();

        mp.currencyswitch.current = newCurrency;
        Cookies.set('MP_UserCurrency', newCurrency, {
            expires: 7,
            path: '/',
            domain: '.' + document.location.hostname,
            secure: (location.protocol === 'https:'),
            samesite: (location.protocol === 'https:' ? 'None' : 'Lax')
        });
        $('.mpCurrencyCode').html(newCurrency);

        mp.currencyswitch.recalculatePrices();
    },

    recalculatePrices: function () {
        if (mpData.currencyRates) {
            $('[data-price]').each(function () {
                var price = mp.currencyswitch.fromEuro(parseFloat($(this).data('price')), mp.currencyswitch.current);

                price = $.number(price, 0, mpData.config.numberFormat.decimal, mpData.config.numberFormat.digit);

                if(typeof($(this).data('add-currency')) !== 'undefined') {
                    price += ' ' + mp.currencyswitch.current;
                }

                if(typeof($(this).data('placeholder-txt')) === 'string') {
                    var txt = $(this).data('placeholder-txt');
                    price = txt.replace("-PRICE-", price);
                }

                $(this).html(price);
            });
        }

        $('.mpCurrencySelect').val(mp.currencyswitch.current).show();
    },

    fromEuro: function (price, currency) {
        if (currency === 'EUR') {
            return Math.round(price);
        }

        return Math.round((price / mpData.currencyRates.EUR) * mpData.currencyRates[currency]);
    }
};

$(document).ready(function () {
    mp.currencyswitch.init();
});